export const IS_LOYALTY_MEMBER = 'IsLoyaltyMember';
export const LOYALTY_LEVEL = 'LoyaltyLevel';
export const LOYALTY_POINTS = 'LoyaltyPoints';
